import { h } from "@stencil/core";
import { i18nProvider } from "@trumpf/ux.i18n";

export const ModalForm = (options) => {
    const { t } = i18nProvider;
    const renderSwitchItem = (type: string) => {
        const isAvailable =
            options.subscriptionData.subscriptionDetails[
                `isAvailableFor${type}Updates`
            ];
        const isSubscribed =
            options.subscriptionData.subscriptionDetails[
                `isSubscribedFor${type}Updates`
            ];
        const labelKey = `softwareUpdates:updateTypes.${type}.label`;
        const tooltipKey = `softwareUpdates:updateTypes.${type}.modalTooltip.copy`;

        if (isSubscribed || isAvailable) {
            return (
                <div class="ux-iws-software-update__modal-switch-item ux-u-mb-xxs">
                    <ux-switch-input
                        data-type={`${type}UpdatesSubscribed`}
                        checked={isSubscribed}
                        label={t(labelKey)}
                        label-placement="end"
                        data-testid={`input-${type}`}
                    ></ux-switch-input>
                    <ux-icon
                        name="info"
                        class="ux-u-ml-xxxs"
                        data-testid="info"
                    ></ux-icon>
                    <ux-tooltip
                        tooltip-target="ux-icon[name='info']"
                        align="bottom"
                    >
                        <div class="ux-text-normal ux-u-mb-xxxs">
                            {t(tooltipKey)}
                        </div>
                        <a
                            href={options.tooltipLink}
                            target="_blank"
                            class="ux-text-link ux-text-link--green"
                        >
                            {t("softwareUpdates:learnMore")}
                            <ux-icon name="arrow-small-right" />
                        </a>
                    </ux-tooltip>
                    <input type="hidden" name={`${type}UpdatesSubscribed`} />
                </div>
            );
        }
        return null;
    };

    return (
        <ux-modal
            close-on-esc-key="false"
            close-on-backdrop-click="true"
            name="software-updates-modal-form"
            opened={options.modalFormState}
            sticky-position="center"
            key={options.key}
        >
            <ux-modal-content>
                {(options.modalFormSpinnerGetState ||
                    options.modalFormSpinnerPostState) && (
                    <ux-spinner-overlay opened></ux-spinner-overlay>
                )}
                <ux-form onUxFormValidated={options.onFormValidated}>
                    <form>
                        <div class="ux-row ux-u-mb-fluid-xxxs">
                            <div class="ux-col-12 ux-col-xl-10 ux-u-offset-xl-1">
                                <h2 class="ux-text-headline ux-text-headline--gian ux-u-my-xs ux-u-text-align--center">
                                    {t("softwareUpdates:modal.headline")}
                                </h2>
                                <p class="ux-text-normal ux-u-mb-zero">
                                    {t("softwareUpdates:modal.copy.1")}
                                </p>
                                <p class="ux-text-normal ux-u-mb-zero">
                                    {t("softwareUpdates:modal.copy.2")}{" "}
                                    <a
                                        class="ux-text-link ux-text-link--green"
                                        href={options.readMoreLink}
                                        target="_blank"
                                    >
                                        {t("softwareUpdates:learnMore")}
                                    </a>
                                </p>
                            </div>
                        </div>
                        <div>
                            <div class="ux-row ux-u-mb-fluid-xxxs">
                                <div class="ux-col-12 ux-col-xl-10 ux-u-offset-xl-1">
                                    <label>
                                        {t("softwareUpdates:modal.machine")}
                                    </label>
                                    <div>
                                        {options.subscriptionData.machineName} (
                                        {options.subscriptionData.machineNumber}
                                        )
                                    </div>
                                </div>
                            </div>
                            <div class="ux-row ux-u-mb-fluid-xxs">
                                <div class="ux-col-12 ux-col-xl-10 ux-u-offset-xl-1">
                                    <div>
                                        <label>
                                            {t(
                                                "softwareUpdates:modal.formHeadline"
                                            )}
                                        </label>
                                        {renderSwitchItem("Security")}
                                        {renderSwitchItem("Functional")}
                                        {renderSwitchItem("Force")}

                                        <input
                                            type="hidden"
                                            name="machineNumber"
                                            value={
                                                options.subscriptionData
                                                    .machineNumber
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                            <div
                                class={`ux-row ux-u-flex-jc-between ${
                                    !options.updatesSubscribed && "ux-u-d-none"
                                }`}
                            >
                                <div class="ux-col-12 ux-col-xl-10 ux-u-offset-xl-1">
                                    <ux-checkbox
                                        class="ux-iws-software-updates__legal-checkbox"
                                        value={options.updatesSubscribed}
                                        name="acceptedLegalTerms"
                                        required={options.updatesSubscribed}
                                        data-validation-required--msg={t(
                                            "softwareUpdates:modal.form.field.privacyPolicy.validationError"
                                        )}
                                    >
                                        <span class="ux-text-normal ux-text-normal--light-gray">
                                            {t(
                                                "softwareUpdates:modal.form.field.privacyPolicy.label"
                                            )}{" "}
                                            <a
                                                class="ux-text-link ux-text-link--green"
                                                href={options.privacyPolicyLink}
                                                target="_blank"
                                            >
                                                {t(
                                                    "softwareUpdates:modal.form.field.privacyPolicy.linkLabel"
                                                )}
                                            </a>
                                        </span>
                                    </ux-checkbox>
                                </div>
                            </div>
                        </div>
                        <div class="ux-row ux-u-mt-fluid-xxs">
                            <div class="ux-col-12 ux-col-md-6 ux-col-xl-5 ux-u-offset-xl-1 ux-u-mb-xs ux-u-mb-md-zero">
                                <ux-button
                                    type="button"
                                    class="ux-u-w-100 ux-u-w-md-auto"
                                    data-trigger-modal="close,software-updates-modal-form"
                                >
                                    {t(
                                        "softwareUpdates:modal.form.field.buttons.cancel"
                                    )}
                                </ux-button>
                            </div>
                            <div class="ux-col-12 ux-col-md-6 ux-col-xl-5 ux-u-d-md-flex ux-u-flex-jc-md-end">
                                <ux-button
                                    type="submit"
                                    class="ux-u-w-100 ux-u-w-md-auto"
                                    variant="primary"
                                >
                                    {t(
                                        "softwareUpdates:modal.form.field.buttons.submit"
                                    )}
                                </ux-button>
                            </div>
                        </div>
                    </form>
                </ux-form>
            </ux-modal-content>
        </ux-modal>
    );
};

export const ModalMessageSuccess = (options) => {
    const { t } = i18nProvider;
    return (
        <ux-modal
            close-on-esc-key="false"
            close-on-backdrop-click="true"
            sticky-position="center"
            opened={options.modalMessageSuccessState}
            name="software-updates-modal-message-success"
        >
            <ux-modal-content>
                <div class="ux-u-d-flex ux-u-flex-ai-center ux-u-flex-dir-column">
                    <span class="ux-color-success">
                        <ux-icon
                            name="checkmark"
                            weight="light"
                            size-s="50"
                            size-m="80"
                        ></ux-icon>
                    </span>
                    <h2 class="ux-text-headline ux-text-headline--big ux-u-text-align--center ux-u-mb-zero ux-color-success">
                        {t("softwareUpdates:modal.changeSaved")}
                    </h2>
                    <ux-button
                        class="ux-u-mt-fluid-xxs"
                        data-trigger-modal="close,software-updates-modal-message-success"
                    >
                        {t("softwareUpdates:closeModalButton")}
                    </ux-button>
                </div>
            </ux-modal-content>
        </ux-modal>
    );
};

export const ModalMessageError = (options) => {
    const { t } = i18nProvider;

    return (
        <ux-modal
            close-on-esc-key="false"
            close-on-backdrop-click="true"
            sticky-position="center"
            opened={options.modalMessageErrorState}
            name="software-updates-modal-message-error"
        >
            <ux-modal-content>
                <div class="ux-u-d-flex ux-u-flex-ai-center ux-u-flex-dir-column">
                    <span class="ux-color-warning">
                        <ux-icon
                            name="triangle-warning"
                            weight="light"
                            size-s="50"
                            size-m="80"
                        ></ux-icon>
                    </span>
                    <h2 class="ux-text-headline ux-text-headline--big ux-u-text-align--center ux-u-mb-zero ux-color-warning">
                        {t("softwareUpdates:modal.errorHeadline")}
                    </h2>
                    <ux-button
                        class="ux-u-mt-fluid-xxs"
                        data-trigger-modal="close,software-updates-modal-message-error"
                    >
                        {t("softwareUpdates:closeModalButton")}
                    </ux-button>
                </div>
            </ux-modal-content>
        </ux-modal>
    );
};
